// import * as React from "react";
// import useNotification from "../common/Notification";
// import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import {
//     TextField,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     CircularProgress,
//     IconButton,
// } from "@mui/material";
// import { Chip } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import Modal from "@mui/material/Modal";
// import { useEffect, useState, useRef } from "react";
// import Cookies from "js-cookie";
// import axios from "axios";
// import CancelIcon from "@mui/icons-material/Cancel";
// import CustomizedDrawer from "../Email/CustomizedDrawer";
// import { useConfirmation } from "../../context/ConfirmationDialogProvider";
// const base_url = "http://api.virtualprachar.com/api/whatsapp/personal/group";

// const baseUrl =
//     "http://api.virtualprachar.com/api/whatsapp/personal/whatsapp_queue";

// const style = {
//     // position: "absolute",
//     // top: "50%",
//     // left: "50%",
//     // transform: "translate(-50%, -50%)",
//     width: "50%",
//     // bgcolor: "background.paper",
//     // border: "2px solid #000",
//     // boxShadow: 24,
//     p: 4,
// };

// const fetchTemplates = async (userId) => {
//     try {
//         const response = await axios.get(
//             "http://api.virtualprachar.com/api/templates",
//             {
//                 params: {
//                     userId,
//                     role: "PERSONAL", // or whatever role is appropriate
//                 },
//             }
//         );
//         return response.data.data || [];
//     } catch (error) {
//         console.error("Error fetching templates:", error);
//         return [];
//     }
// };

// const AddNumber = () => {
//     const [phoneNumber, setPhoneNumber] = useState([]);
//     const [contacts, setContacts] = useState([]);
//     const [phoneValue, setPhoneValue] = useState("");
//     const [customMessage, setCustomMessage] = useState("");
//     const [data, setData] = useState([]);
//     const [image, setImage] = useState([]);
//     const [open, setOpen] = React.useState(false);
//     const [searchedGName, setSearchGName] = useState("");
//     const [options, setOptions] = useState([]);
//     const [filteredData, setFiltereData] = useState([]);
//     const [userId, setUserId] = useState(Cookies.get("userId"));
//     const [page, setPage] = useState(1);
//     const [loading, setLoading] = useState(false);
//     const [totalPage, setTotalPage] = useState(1);
//     const [imgUrl, setImgUrl] = useState("");
//     const [drawerOpen, setDrawerOpen] = useState(false);
//     const [sendStatus, setSendStatus] = useState(false);
//     const showNotification = useNotification();
//     const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false);
//     const notify = useNotification();
//     const [btnLoading, setBtnLoading] = useState(false);
//     const [message, setMessage] = useState("");
//     const showConfirmation = useConfirmation();

//     const [templates, setTemplates] = useState([]);
//     const [selectedTemplate, setSelectedTemplate] = useState(null);
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//     const fileInputRef = useRef(null);
//     const fetchingOptions = async () => {
//         try {
//             const res = await axios.get(`${base_url}/get/${userId}`);
//             console.log(res.data.data);
//             let data = new Set();
//             for (let obj of res.data.data) {
//                 data.add(obj.group_name);
//             }
//             let newData = [];
//             data.forEach((e) => {
//                 newData.push(e);
//             });
//             // setOptions(res.data.data);
//             setSearchGName("");
//             setOptions(newData);
//         } catch (e) {
//             console.error("Error: ", e);
//         }
//     };

//     // Add this useEffect to fetch templates when component mounts
//     useEffect(() => {
//         const loadTemplates = async () => {
//             const fetchedTemplates = await fetchTemplates(userId);
//             setTemplates(fetchedTemplates);
//         };
//         loadTemplates();
//     }, [userId]);

//     // Add this function to handle template selection
//     const handleTemplateSelect = (template) => {
//         setSelectedTemplate(template);
//         setCustomMessage(template.content);
//     };

//     useEffect(() => {
//         fetchingOptions();
//     }, []);

//     const handlePhoneChange = (e) => {
//         setPhoneValue(e.target.value);
//         // setContacts([]);
//         // setSearchGName("");
//         // setTotalPage(1);
//         // setPage(1);
//         // setFiltereData([]);
//     };

//     const handleAddNumber = () => {
//         console.log(phoneValue);
//         if (!phoneValue) {
//             showNotification("Please enter a phone number!", "warning");
//             // alert("Please enter a phone number");
//             return;
//         }

//         let formattedNumber = phoneValue.replace(/\D/g, "");
//         if (!formattedNumber.startsWith("91")) {
//             formattedNumber = `91${formattedNumber}`;
//         }

//         // const phonePattern = /^91[0-9]{10}$/;
//         // const phonePattern = /^[0-9]{10}$/;
//         const phonePattern = /^[0-9]{12}$/;

//         if (!phonePattern.test(formattedNumber)) {
//             // alert(
//             //     "Invalid phone number. Please enter a valid 10-digit number with Country code."
//             // );
//             showNotification("Invalid phone number", "warning");
//             return;
//         }

//         setPhoneNumber((prev) => [...prev, formattedNumber]);
//         setContacts((prev) => [
//             ...prev,
//             { phoneNumber: formattedNumber, name: null },
//         ]);
//         setPhoneValue("");
//     };

//     const handleDelete = (idx) => {
//         setContacts((prev) => prev.filter((_, i) => i !== idx));
//         setPhoneNumber((prev) => prev.filter((_, i) => i !== idx));
//     };

//     const handleImageChange = (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         const maxSize = 10 * 1024 * 1024; // 10MB

//         const validTypes = [
//             "image/jpeg",
//             "image/png",
//             "image/jpg",
//             "application/pdf",
//             "video/mp4",
//         ];

//         if (!validTypes.includes(file.type)) {
//             // alert("Invalid file type. Please upload an image, PDF, or MP4 video.");
//             notify(
//                 "Invalid file type. Please upload an image, PDF, or MP4 video.",
//                 "error"
//             );
//             return;
//         }

//         if (file.size > maxSize) {
//             // alert("File size exceeds 10MB. Please upload a smaller file.");
//             notify(
//                 "File size exceeds 10MB. Please upload a smaller file.",
//                 "error"
//             );
//             return;
//         }

//         setImage((prev) => [...prev, file]); // Or use a more general name like setMedia(file)
//     };

//     const handleImageUpload = async () => {
//         if (image.length === 0) {
//             notify("No file has been selected.", "error");
//             return;
//         }
//         const payload = new FormData();
//         payload.append("image", image[0]);
//         payload.append("user_id", userId);
//         setBtnLoading(true);
//         try {
//             const res = await axios.post(
//                 "http://api.virtualprachar.com/api/upload/image",
//                 payload
//             );
//             // showNotification("Image Uploaded!", "success");
//             console.log(res.data.path);
//             const newUrl = `http://api.virtualprachar.com/${res.data.path}`;
//             notify("File uploaded successfully!", "success");
//             console.log(newUrl);
//             setImgUrl(newUrl);
//         } catch (e) {
//             console.log("Error: ", e);
//             if (e.status == 409) {
//                 notify(`${e.response?.data?.message}`, "error");
//                 return;
//             }

//             if (e.status === 413) {
//                 notify(`${e.response?.data.message}`, "error");
//                 return;
//             }
//             if (e.status === 422) {
//                 notify(`${e.response?.data.message}`, "error");
//                 return;
//             }
//             notify(`${e.message}`, "error");
//             console.log("Error: ", e);
//             notify(`${e.message}`, "error");
//         } finally {
//             setBtnLoading(false);
//         }
//     };

//     const handleClearUploads = () => {
//         setImage([]);
//         setImgUrl("");
//         if (fileInputRef.current) {
//             fileInputRef.current.value = ""; // This clears the actual file input
//         }
//     };

//     const handleSubmit = async () => {
//         let payload;
//         // if (!customMessage) {
//         //     // alert("Please enter a custom message.");
//         //     showNotification("Please enter a custom message!", "warning");
//         //     return;
//         // }

//         if (searchedGName) {
//             payload = [
//                 {
//                     user_id: userId,
//                     group_name: searchedGName,
//                     image_url: imgUrl,
//                     message: customMessage,
//                 },
//             ];

//             setDrawerOpen(true);
//             // alert("Do you want to continue with group ? ");
//             return;

//             console.log("payload for group");
//         } else {
//             console.log(phoneNumber);
//             const userId = Cookies.get("userId");
//             payload = phoneNumber.map((phone) => {
//                 return {
//                     user_id: userId,
//                     phone_number: phone,
//                     message: customMessage,
//                     // name: "",
//                     image_url: imgUrl,
//                 };
//             });

//             if (phoneNumber.length === 0) {
//                 // alert("Please add at least one phone number.");
//                 showNotification(
//                     "Please add at least one phone number!",
//                     "warning"
//                 );
//                 return;
//             }

//             console.log("Payload for single test");
//         }
//         if (image.length != 0 && !imgUrl) {
//             notify("Selected File has not been uploaded yet.", "error");
//             return;
//         }
//         if (!customMessage) {
//             if (image.length === 0) {
//                 notify(
//                     "Both the file and the custom message field cannot be empty",
//                     "error"
//                 );
//                 return;
//             }
//             const confirm = await showConfirmation(
//                 "Do you want to proceed without message?"
//             );
//             if (!confirm) return;
//         }

//         // if (!image.length != 0) {
//         //     const confirm = await showConfirmation(
//         //         "Do you want to proceed without message?"
//         //     );
//         //     if (!confirm) return;
//         // }

//         const formData = new FormData();
//         formData.append("phoneNumbers", JSON.stringify(phoneNumber));
//         formData.append("customMessage", customMessage);
//         if (image) formData.append("image", image);
//         console.log(data);

//         // return;

//         try {
//             const response = await axios.post(`${baseUrl}/add`, payload);
//             console.log("✅ Data sent successfully:", response.data);
//             // alert("Data sent successfully!");
//             showNotification("Message added in queue!", "success");
//         } catch (error) {
//             console.error("❌ Error sending data:", error);
//             showNotification(
//                 "Something went wrong, please try again!",
//                 "error"
//             );
//             // alert("Failed to send data");
//         }
//     };
//     const handleCustomMessageChange = (e) => {
//         setCustomMessage(e.target.value);
//     };

//     const handleSelectionChange = (e) => {
//         setSearchGName(e.target.value);
//         setPage(1);
//         setContacts([]);
//     };

//     // Fetching group data

//     const fetchGroupData = async () => {
//         if (!page) page = 1;
//         if (!searchedGName) {
//             alert("Please enter group name!");

//             return;
//         }
//         try {
//             setLoading(true);
//             showNotification("This might take few seconds!", "info");

//             // setSearchGName("");
//             const res = await axios.get(
//                 `${base_url}/get?user_id=${userId}&group_name=${searchedGName}&page=${page}`
//             );
//             setFiltereData(res.data.data.data);
//             console.log(res.data.data.data);
//             const newData = res.data.data.data.map((obj) => {
//                 return {
//                     phoneNumber: obj.phone_number,
//                     name: null,
//                 };
//             });
//             setContacts((prev) => [...prev, ...newData]);
//             setPage((prev) => prev + 1);

//             setTotalPage(res.data.data.last_page);
//         } catch (e) {
//             console.error("Error: ", e);
//             showNotification("Error while loading group data!", "error");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSaveContent = async () => {
//         // if (!sendStatus) {
//         //     return;
//         // }
//         let payload = [
//             {
//                 user_id: userId,
//                 group_name: searchedGName,
//                 image_url: imgUrl,
//                 message: customMessage,
//             },
//         ];

//         if (image.length != 0 && !imgUrl) {
//             notify("File has not been uploaded yet.", "error");
//             return;
//         }

//         if (!customMessage) {
//             if (image.length === 0) {
//                 notify(
//                     "Both the file and the custom message field cannot be empty",
//                     "error"
//                 );
//                 return;
//             }
//             const confirm = await showConfirmation(
//                 "Do you want to proceed without message?"
//             );
//             if (!confirm) return;
//         }
//         const formData = new FormData();
//         formData.append("phoneNumbers", JSON.stringify(phoneNumber));
//         formData.append("customMessage", customMessage);
//         if (image) formData.append("image", image);
//         console.log(data);

//         // return;

//         try {
//             const response = await axios.post(`${baseUrl}/add`, payload);
//             console.log("✅ Data sent successfully:", response.data);
//             // alert("Data sent successfully!");
//             showNotification("Message added in queue!", "success");
//         } catch (error) {
//             console.error("❌ Error sending data:", error);
//             showNotification(
//                 "Something went wrong, please try again!",
//                 "error"
//             );
//             // alert("Failed to send data");
//         } finally {
//             setSendStatus(false);
//         }
//     };

//     const closeDrawer = async () => {
//         console.log("Function is called...");
//         setDrawerOpen(false);
//         console.log(drawerOpen);

//         handleSaveContent();
//     };

//     return (
//         <>
//             <div
//                 style={{
//                     // backgroundColor: "violet",
//                     display: "flex",
//                     marginTop: "1rem",
//                     // flexWrap: "wrap",
//                 }}
//             >
//                 <CustomizedDrawer
//                     message={"Do you want to proceed with group ?"}
//                     drawerOpen={drawerOpen}
//                     closeDrawer={closeDrawer}
//                     onCancel={() => setDrawerOpen(false)}
//                 />
//                 <Box sx={style}>
//                     {/* Phone number Fields  */}
//                     <Box
//                         sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             width: "100%",
//                             gap: 1,
//                         }}
//                     >
//                         <TextField
//                             id="outlined-basic"
//                             label="Phone No With Country Code ( eg: 919999999999 )"
//                             variant="outlined"
//                             disabled={searchedGName}
//                             size="small"
//                             sx={{
//                                 width: "100%",
//                                 "@media(max-width:768px)": {
//                                     width: "100%",
//                                 },
//                             }}
//                             value={phoneValue}
//                             onChange={handlePhoneChange}
//                         />
//                         <Button
//                             variant="contained"
//                             size="small"
//                             disabled={searchedGName}
//                             onClick={handleAddNumber}
//                             sx={{
//                                 height: "40px",
//                                 px: "1.5rem",
//                                 bgcolor: "#1976d2",
//                                 "&:hover": {
//                                     bgcolor: "#1565c0",
//                                 },
//                             }}
//                         >
//                             ADD
//                         </Button>
//                     </Box>

//                     {/* Add Template Selection Row Here */}
//                     {templates.length > 0 && (
//                         <Box
//                             sx={{
//                                 width: "100%",
//                                 overflowX: "auto",
//                                 whiteSpace: "nowrap",
//                                 py: 1,
//                                 my: 2,
//                                 border: "1px solid #e0e0e0",
//                                 borderRadius: 1,
//                                 backgroundColor: "#f5f5f5",
//                             }}
//                         >
//                             <Box
//                                 sx={{
//                                     display: "inline-flex",
//                                     gap: 1,
//                                     px: 1,
//                                 }}
//                             >
//                                 {templates.map((template) => (
//                                     <Chip
//                                         key={template.id}
//                                         label={template.title}
//                                         onClick={() =>
//                                             handleTemplateSelect(template)
//                                         }
//                                         variant={
//                                             selectedTemplate?.id === template.id
//                                                 ? "filled"
//                                                 : "outlined"
//                                         }
//                                         color={
//                                             selectedTemplate?.id === template.id
//                                                 ? "primary"
//                                                 : "default"
//                                         }
//                                         sx={{
//                                             cursor: "pointer",
//                                             minWidth: "120px",
//                                             justifyContent: "center",
//                                             "&:hover": {
//                                                 backgroundColor:
//                                                     theme.palette.primary.light,
//                                                 color: theme.palette.primary
//                                                     .contrastText,
//                                             },
//                                         }}
//                                     />
//                                 ))}
//                             </Box>
//                         </Box>
//                     )}

//                     {/* Upload image */}
//                     <Box
//                         sx={{
//                             width: "98%",
//                             gap: 1,

//                             display: "flex",
//                             flexDirection: "column",
//                             marginTop: "1rem",
//                             marginBottom: "1rem",
//                             // width: "60%",
//                             "@media(max-width:768px)": {
//                                 // marginTop: '3rem',
//                                 // flexDirection: "column",

//                                 marginRight: "auto",
//                                 marginLeft: "auto",
//                                 width: "100%",
//                                 // marginRight: -2,
//                             },
//                         }}
//                     >
//                         <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
//                             <Button variant="contained" component="label">
//                                 Select File
//                                 <input
//                                     type="file"
//                                     hidden
//                                     ref={fileInputRef}
//                                     single
//                                     accept=".jpeg,.jpg,.png,.mp4,.pdf"
//                                     onChange={handleImageChange}
//                                     style={{
//                                         // marginBottom: "10px",
//                                         padding: "5px",
//                                         border: "1px solid #ccc",
//                                         borderRadius: "4px",
//                                         width: "auto",
//                                     }}
//                                 />
//                             </Button>
//                             <Button
//                                 variant="contained"
//                                 disabled={image.length === 0 || btnLoading}
//                                 onClick={handleImageUpload}
//                             >
//                                 Upload
//                                 {btnLoading && (
//                                     <CircularProgress
//                                         size={24}
//                                         sx={{
//                                             position: "absolute",
//                                             top: "50%",
//                                             left: "50%",
//                                             marginTop: "-12px",
//                                             marginLeft: "-12px",
//                                         }}
//                                     />
//                                 )}{" "}
//                             </Button>
//                         </Box>

//                         <Box>
//                             {image.length > 0 && (
//                                 <Box
//                                     sx={{
//                                         marginBottom: 1,
//                                         height: "auto",
//                                         width: "auto",
//                                         display: "flex",
//                                         justifyContent: "start",
//                                         alignItems: "center",
//                                         position: "relative",
//                                     }}
//                                 >
//                                     <Box sx={{ height: "auto" }}>
//                                         {image.length > 0 && image[0].name}
//                                     </Box>

//                                     <IconButton
//                                         sx={{
//                                             marginLeft: 1,
//                                             color: "#c90808",
//                                         }}
//                                         onClick={handleClearUploads}
//                                     >
//                                         <CancelIcon color="#e32712" />
//                                     </IconButton>
//                                 </Box>
//                                 // <Typography
//                                 //     variant="body2"
//                                 //     color="green"
//                                 //     sx={{ marginBottom: 1 }}
//                                 // >
//                                 //     Uploaded: {image.name}
//                                 //     <Button
//                                 //         variant="outlined"
//                                 //         onClick={handleClearUploads}
//                                 //         sx={{
//                                 //             color: "#c41b3d",
//                                 //             borderColor: "#c41b3d",
//                                 //             marginLeft: "1rem",
//                                 //             "&:hover": {
//                                 //                 backgroundColor: "#c41b3d",
//                                 //                 color: "#fff",
//                                 //             },
//                                 //         }}
//                                 //     >
//                                 //         Clear
//                                 //     </Button>
//                                 // </Typography>
//                             )}
//                         </Box>
//                     </Box>

//                     {/* Custom Message */}
//                     <Box
//                         sx={{
//                             "@media(max-width:768px)": {
//                                 width: "100%",
//                             },
//                         }}
//                     >
//                         <TextField
//                             id="custom-message"
//                             label="Custom Message"
//                             variant="outlined"
//                             size="small"
//                             value={customMessage}
//                             onChange={handleCustomMessageChange}
//                             multiline
//                             rows={6}
//                             sx={{
//                                 width: "100%",
//                                 mb: 2,
//                                 "@media(max-width:768px)": {
//                                     // marginTop: '3rem',

//                                     marginRight: "auto",
//                                     marginLeft: "auto",
//                                     borderRight: 0,
//                                     width: "100%",
//                                     // paddingBottom: "1rem",
//                                     // borderBottom: 1,
//                                 },
//                             }}
//                         />
//                     </Box>
//                 </Box>

//                 <Box sx={{ width: "50%" }}>
//                     <Box
//                         sx={{
//                             display: "flex",
//                             flexDirection: "column",
//                         }}
//                     >
//                         <Box
//                             fullWidth
//                             sx={{
//                                 gap: 1,
//                                 display: "flex",
//                                 flexWrap: "nowrap",
//                                 flexShrink: 1,
//                                 justifyContent: "end",
//                                 "@media(max-width:768px)": {
//                                     marginRight: "auto",
//                                     marginLeft: "auto",
//                                     borderRight: 0,
//                                 },
//                             }}
//                         >
//                             <FormControl sx={{ width: "12rem" }}>
//                                 <InputLabel size="small">
//                                     Select a group
//                                 </InputLabel>
//                                 <Select
//                                     value={searchedGName}
//                                     label={"Select an Option"}
//                                     onChange={handleSelectionChange}
//                                     size="small"
//                                 >
//                                     {options.map((option, i) => (
//                                         <MenuItem key={i} value={option}>
//                                             {option}
//                                         </MenuItem>
//                                     ))}
//                                 </Select>
//                             </FormControl>
//                             <Button
//                                 variant="outlined"
//                                 size="small"
//                                 onClick={fetchGroupData}
//                             >
//                                 Search
//                             </Button>
//                         </Box>
//                     </Box>

//                     {/* Displaying the contacts  */}

//                     <Box
//                         sx={{
//                             my: 2,
//                             p: 2,
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                             borderRadius: 2,
//                             overflowY: "auto",
//                             minHeight: "200px",
//                             maxHeight: "350px",
//                             width: "300px",
//                             bgcolor: "#0f1a33",
//                             // mx: "auto",
//                             marginLeft: "auto",
//                             flexGrow: 1,
//                             gap: 1.5,
//                         }}
//                     >
//                         {contacts.length === 0 ? (
//                             <Typography
//                                 sx={{ color: "white", fontSize: "14px" }}
//                             >
//                                 Added contacts will be displayed here.
//                             </Typography>
//                         ) : (
//                             <>
//                                 {contacts.map((contact, idx) => (
//                                     <>
//                                         <Chip
//                                             key={idx}
//                                             label={`${contact.phoneNumber}

//                                             `}
//                                             variant="outlined"
//                                             onDelete={() => handleDelete(idx)}
//                                             sx={{
//                                                 fontSize: "14px",
//                                                 height: "32px",
//                                                 color: "white",
//                                                 borderColor:
//                                                     "rgba(255, 255, 255, 0.5)",
//                                                 "& .MuiChip-deleteIcon": {
//                                                     color: "rgba(255, 255, 255, 0.7)",
//                                                 },
//                                             }}
//                                         />
//                                     </>
//                                 ))}

//                                 {loading && (
//                                     <CircularProgress
//                                         sx={{ color: "#f5f7f7" }}
//                                     />
//                                 )}
//                                 {!loading && page < totalPage && (
//                                     <Button
//                                         variant="outlined"
//                                         size="small"
//                                         onClick={fetchGroupData}
//                                     >
//                                         Load More
//                                     </Button>
//                                 )}
//                             </>
//                         )}
//                     </Box>
//                     <Box
//                         sx={{
//                             width: "100%",
//                             // backgroundColor: "orange",
//                             display: "flex",
//                             justifyContent: "end",
//                         }}
//                     >
//                         <Button
//                             variant="contained"
//                             size="small"
//                             onClick={handleSubmit}
//                             sx={{
//                                 width: "100px",
//                             }}
//                         >
//                             Send
//                         </Button>
//                         <Button
//                             variant="outlined"
//                             size="small"
//                             onClick={() => {
//                                 setContacts([]);
//                                 setPhoneNumber([]);
//                                 setPage(1);
//                                 setSearchGName("");
//                             }}
//                             sx={{
//                                 width: "auto",
//                                 marginLeft: "10px",
//                                 color: "#c41b3d",
//                                 borderColor: "#c41b3d",
//                                 "&:hover": {
//                                     backgroundColor: "#c41b3d",
//                                     color: "#fff",
//                                 },
//                             }}
//                         >
//                             {searchedGName ? "Clear Group" : "Clear Contacts"}
//                         </Button>
//                     </Box>
//                 </Box>

//                 {/* </Modal> */}
//             </div>

//             <Box sx={{ width: "100%" }}>
//                 <Box
//                     sx={{
//                         marginTop: "auto",
//                         width: "auto",
//                         padding: "1rem",
//                         border: 1,
//                         borderColor: "#88898a",
//                         textAlign: "start",
//                         fontSize: "0.75rem",
//                         borderRadius: 1,
//                     }}
//                 >
//                     <p
//                         style={{
//                             fontSize: "0.95rem",
//                             fontWeight: "900",
//                             textAlign: "start",
//                             width: "100%",
//                         }}
//                     >
//                         Note*
//                     </p>
//                     <ul>
//                         <li>
//                             <strong>Bold:</strong> To make text bold, put a{" "}
//                             <strong>*</strong> (star) before and after the word.
//                             For example, type <code>*hello*</code> → it will
//                             appear as <strong>hello</strong>.
//                         </li>
//                         <li>
//                             <strong>Italic:</strong> To make text slanted, put
//                             an <strong>_</strong> (underscore) before and after
//                             the word. For example, type <code>_hello_</code> →
//                             it will appear as <em>hello</em>.
//                         </li>
//                         <li>
//                             <strong>Strikethrough:</strong> To cross out text,
//                             put a <strong>~</strong> (tilde) before and after
//                             the word. For example, type <code>~hello~</code> →
//                             it will appear as <s>hello</s>.
//                         </li>
//                         <li>
//                             <strong>Monospace:</strong> To use a
//                             typewriter-style font, put <strong>```</strong>{" "}
//                             (three backticks) before and after the word. For
//                             example, type <code>```hello```</code> → it will
//                             appear as <code>hello</code>.
//                         </li>
//                     </ul>
//                 </Box>
//             </Box>
//         </>
//     );
// };

// export default AddNumber;

// import * as React from "react";
// import useNotification from "../common/Notification";
// import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import {
//     TextField,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     CircularProgress,
//     IconButton,
//     Stepper,
//     Step,
//     StepLabel,
//     Paper,
//     Chip,
//     Avatar,
//     Divider,
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useEffect, useState, useRef } from "react";
// import Cookies from "js-cookie";
// import axios from "axios";
// import CancelIcon from "@mui/icons-material/Cancel";
// import CustomizedDrawer from "../Email/CustomizedDrawer";
// import { useConfirmation } from "../../context/ConfirmationDialogProvider";
// import MessageStep from "./AddMessageSteppersCmp/MessageStep";
// import RecipientStep from "./AddMessageSteppersCmp/RecipientStep";
// import AttachmentStep from "./AddMessageSteppersCmp/AttachmentStep";

// const base_url = "http://api.virtualprachar.com/api/whatsapp/personal/group";
// const baseUrl =
//     "http://api.virtualprachar.com/api/whatsapp/personal/whatsapp_queue";

// const steps = ["Message", "Attachments", "Recipients"];

// const fetchTemplates = async (userId) => {
//     try {
//         const response = await axios.get(
//             "http://api.virtualprachar.com/api/templates",
//             {
//                 params: { userId, role: "PERSONAL" },
//             }
//         );
//         return response.data.data || [];
//     } catch (error) {
//         console.error("Error fetching templates:", error);
//         return [];
//     }
// };

// const AddNumber = () => {
//     const [activeStep, setActiveStep] = useState(0);
//     const [phoneNumber, setPhoneNumber] = useState([]);
//     const [contacts, setContacts] = useState([]);
//     const [phoneValue, setPhoneValue] = useState("");
//     const [customMessage, setCustomMessage] = useState("");
//     const [image, setImage] = useState([]);
//     const [searchedGName, setSearchGName] = useState("");
//     const [options, setOptions] = useState([]);
//     const [filteredData, setFiltereData] = useState([]);
//     const [userId] = useState(Cookies.get("userId"));
//     const [page, setPage] = useState(1);
//     const [loading, setLoading] = useState(false);
//     const [totalPage, setTotalPage] = useState(1);
//     const [imgUrl, setImgUrl] = useState("");
//     const [drawerOpen, setDrawerOpen] = useState(false);
//     const [btnLoading, setBtnLoading] = useState(false);
//     const showConfirmation = useConfirmation();
//     const [templates, setTemplates] = useState([]);
//     const [selectedTemplate, setSelectedTemplate] = useState(null);
//     const fileInputRef = useRef(null);
//     const notify = useNotification();

//     useEffect(() => {
//         const loadTemplates = async () => {
//             const fetchedTemplates = await fetchTemplates(userId);
//             setTemplates(fetchedTemplates);
//         };
//         loadTemplates();
//         fetchingOptions();
//     }, [userId]);

//     const fetchingOptions = async () => {
//         try {
//             const res = await axios.get(`${base_url}/get/${userId}`);
//             const uniqueGroupNames = [
//                 ...new Set(res.data.data.map((obj) => obj.group_name)),
//             ];
//             setOptions(uniqueGroupNames);
//         } catch (e) {
//             console.error("Error: ", e);
//         }
//     };

//     const handleNext = () => setActiveStep((prev) => prev + 1);
//     const handleBack = () => setActiveStep((prev) => prev - 1);

//     const handleTemplateSelect = (template) => {
//         setSelectedTemplate(template);
//         setCustomMessage(template.content);
//     };

//     const handlePhoneChange = (e) => setPhoneValue(e.target.value);

//     const handleAddNumber = () => {
//         if (!phoneValue) {
//             notify("Please enter a phone number!", "warning");
//             return;
//         }

//         let formattedNumber = phoneValue.replace(/\D/g, "");
//         if (!formattedNumber.startsWith("91")) {
//             formattedNumber = `91${formattedNumber}`;
//         }

//         if (!/^[0-9]{12}$/.test(formattedNumber)) {
//             notify("Invalid phone number", "warning");
//             return;
//         }

//         setPhoneNumber((prev) => [...prev, formattedNumber]);
//         setContacts((prev) => [
//             ...prev,
//             { phoneNumber: formattedNumber, name: null },
//         ]);
//         setPhoneValue("");
//     };

//     const handleDelete = (idx) => {
//         setContacts((prev) => prev.filter((_, i) => i !== idx));
//         setPhoneNumber((prev) => prev.filter((_, i) => i !== idx));
//     };

//     const handleImageChange = (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         const validTypes = [
//             "image/jpeg",
//             "image/png",
//             "image/jpg",
//             "application/pdf",
//             "video/mp4",
//         ];
//         if (!validTypes.includes(file.type)) {
//             notify(
//                 "Invalid file type. Please upload an image, PDF, or MP4 video.",
//                 "error"
//             );
//             return;
//         }

//         if (file.size > 10 * 1024 * 1024) {
//             notify(
//                 "File size exceeds 10MB. Please upload a smaller file.",
//                 "error"
//             );
//             return;
//         }

//         setImage([file]);
//     };

//     const handleImageUpload = async () => {
//         if (image.length === 0) {
//             notify("No file has been selected.", "error");
//             return;
//         }

//         const payload = new FormData();
//         payload.append("image", image[0]);
//         payload.append("user_id", userId);

//         setBtnLoading(true);
//         try {
//             const res = await axios.post(
//                 "http://api.virtualprachar.com/api/upload/image",
//                 payload
//             );
//             const newUrl = `http://api.virtualprachar.com/${res.data.path}`;
//             notify("File uploaded successfully!", "success");
//             setImgUrl(newUrl);
//         } catch (e) {
//             console.error("Error: ", e);
//             notify(e.response?.data?.message || e.message, "error");
//         } finally {
//             setBtnLoading(false);
//         }
//     };

//     const handleClearUploads = () => {
//         setImage([]);
//         setImgUrl("");
//         if (fileInputRef.current) fileInputRef.current.value = "";
//     };

//     const handleSelectionChange = (e) => {
//         setSearchGName(e.target.value);
//         setPage(1);
//         setContacts([]);
//     };

//     const fetchGroupData = async () => {
//         if (!searchedGName) {
//             notify("Please enter group name!", "warning");
//             return;
//         }

//         try {
//             setLoading(true);
//             const res = await axios.get(
//                 `${base_url}/get?user_id=${userId}&group_name=${searchedGName}&page=${page}`
//             );

//             const newData = res.data.data.data.map((obj) => ({
//                 phoneNumber: obj.phone_number,
//                 name: null,
//             }));

//             setContacts((prev) => [...prev, ...newData]);
//             setPage((prev) => prev + 1);
//             setTotalPage(res.data.data.last_page);
//         } catch (e) {
//             console.error("Error: ", e);
//             notify("Error while loading group data!", "error");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleClearContacts = () => {
//         setContacts([]);
//         setPhoneNumber([]);
//         setPage(1);
//         setSearchGName("");
//     };

//     const handleSubmit = async () => {
//         if (image.length !== 0 && !imgUrl) {
//             notify("Selected File has not been uploaded yet.", "error");
//             return;
//         }

//         if (!customMessage && image.length === 0) {
//             const confirm = await showConfirmation(
//                 "Do you want to proceed without message?"
//             );
//             if (!confirm) return;
//         }

//         let payload;
//         if (searchedGName) {
//             payload = [
//                 {
//                     user_id: userId,
//                     group_name: searchedGName,
//                     image_url: imgUrl,
//                     message: customMessage,
//                 },
//             ];
//             setDrawerOpen(true);
//             return;
//         } else {
//             if (phoneNumber.length === 0) {
//                 notify("Please add at least one phone number!", "warning");
//                 return;
//             }

//             payload = phoneNumber.map((phone) => ({
//                 user_id: userId,
//                 phone_number: phone,
//                 message: customMessage,
//                 image_url: imgUrl,
//             }));
//         }

//         try {
//             await axios.post(`${baseUrl}/add`, payload);
//             notify("Message added in queue!", "success");
//             // Reset form
//             setCustomMessage("");
//             setImage([]);
//             setImgUrl("");
//             setPhoneNumber([]);
//             setContacts([]);
//             setActiveStep(0);
//         } catch (error) {
//             console.error("Error sending data:", error);
//             notify("Something went wrong, please try again!", "error");
//         }
//     };

//     const handleSaveContent = async () => {
//         try {
//             await axios.post(`${baseUrl}/add`, [
//                 {
//                     user_id: userId,
//                     group_name: searchedGName,
//                     image_url: imgUrl,
//                     message: customMessage,
//                 },
//             ]);
//             notify("Message added in queue!", "success");
//             setDrawerOpen(false);
//             // Reset form
//             setCustomMessage("");
//             setImage([]);
//             setImgUrl("");
//             setPhoneNumber([]);
//             setContacts([]);
//             setActiveStep(0);
//         } catch (error) {
//             console.error("Error sending data:", error);
//             notify("Something went wrong, please try again!", "error");
//         }
//     };

//     const closeDrawer = () => {
//         setDrawerOpen(false);
//         handleSaveContent();
//     };

//     return (
//         <Box sx={{ width: "100%", p: 3 }}>
//             <CustomizedDrawer
//                 message={"Do you want to proceed with group?"}
//                 drawerOpen={drawerOpen}
//                 closeDrawer={closeDrawer}
//                 onCancel={() => setDrawerOpen(false)}
//             />

//             <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
//                 {steps.map((label) => (
//                     <Step key={label}>
//                         <StepLabel>{label}</StepLabel>
//                     </Step>
//                 ))}
//             </Stepper>

//             <Paper sx={{ p: 3, mb: 3 }}>
//                 {activeStep === 0 && (
//                     <MessageStep
//                         templates={templates}
//                         selectedTemplate={selectedTemplate}
//                         onTemplateSelect={handleTemplateSelect}
//                         customMessage={customMessage}
//                         onMessageChange={(e) =>
//                             setCustomMessage(e.target.value)
//                         }
//                     />
//                 )}

//                 {activeStep === 1 && (
//                     <AttachmentStep
//                         image={image}
//                         imgUrl={imgUrl}
//                         btnLoading={btnLoading}
//                         onImageChange={handleImageChange}
//                         onImageUpload={handleImageUpload}
//                         onClearUploads={handleClearUploads}
//                         fileInputRef={fileInputRef}
//                     />
//                 )}

//                 {activeStep === 2 && (
//                     <RecipientStep
//                         phoneValue={phoneValue}
//                         phoneNumber={phoneNumber}
//                         contacts={contacts}
//                         searchedGName={searchedGName}
//                         options={options}
//                         loading={loading}
//                         page={page}
//                         totalPage={totalPage}
//                         onPhoneChange={handlePhoneChange}
//                         onAddNumber={handleAddNumber}
//                         onDelete={handleDelete}
//                         onSelectionChange={handleSelectionChange}
//                         onFetchGroupData={fetchGroupData}
//                         onClearContacts={handleClearContacts}
//                     />
//                 )}
//             </Paper>

//             <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                 <Button
//                     disabled={activeStep === 0}
//                     onClick={handleBack}
//                     sx={{ mr: 1 }}
//                 >
//                     Back
//                 </Button>

//                 {activeStep === steps.length - 1 ? (
//                     <Button
//                         variant="contained"
//                         onClick={handleSubmit}
//                         disabled={
//                             contacts.length === 0 && phoneNumber.length === 0
//                         }
//                     >
//                         Send Message
//                     </Button>
//                 ) : (
//                     <Button variant="contained" onClick={handleNext}>
//                         Next
//                     </Button>
//                 )}
//             </Box>

//             <Box
//                 sx={{
//                     mt: 4,
//                     p: 2,
//                     border: 1,
//                     borderColor: "divider",
//                     borderRadius: 1,
//                 }}
//             >
//                 <Typography
//                     variant="subtitle1"
//                     gutterBottom
//                     sx={{ fontWeight: "bold" }}
//                 >
//                     Note*
//                 </Typography>
//                 <ul style={{ paddingLeft: "20px", margin: 0 }}>
//                     <li>
//                         <strong>Bold:</strong> *text* → <strong>text</strong>
//                     </li>
//                     <li>
//                         <strong>Italic:</strong> _text_ → <em>text</em>
//                     </li>
//                     <li>
//                         <strong>Strikethrough:</strong> ~text~ → <s>text</s>
//                     </li>
//                     <li>
//                         <strong>Monospace:</strong> ```text``` →{" "}
//                         <code>text</code>
//                     </li>
//                 </ul>
//             </Box>
//         </Box>
//     );
// };

// export default AddNumber;

import * as React from "react";
import useNotification from "../common/Notification";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    IconButton,
    Stepper,
    Step,
    StepLabel,
    Paper,
    Chip,
} from "@mui/material";
import { useEffect, useState, useRef } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import CancelIcon from "@mui/icons-material/Cancel";
import CustomizedDrawer from "../Email/CustomizedDrawer";
import { useConfirmation } from "../../context/ConfirmationDialogProvider";
import MessageStep from "./AddMessageSteppersCmp/MessageStep";
import RecipientStep from "./AddMessageSteppersCmp/RecipientStep";
import AttachmentStep from "./AddMessageSteppersCmp/AttachmentStep";

const base_url = "http://api.virtualprachar.com/api/whatsapp/personal/group";
const baseUrl =
    "http://api.virtualprachar.com/api/whatsapp/personal/whatsapp_queue";

const steps = ["Content", "Attachments", "Recipients"];

const AddNumber = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [phoneNumber, setPhoneNumber] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [phoneValue, setPhoneValue] = useState("");
    const [customMessage, setCustomMessage] = useState("");
    const [image, setImage] = useState([]);
    const [searchedGName, setSearchGName] = useState("");
    const [options, setOptions] = useState([]);
    const [userId] = useState(Cookies.get("userId"));
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalPage, setTotalPage] = useState(1);
    const [imgUrl, setImgUrl] = useState("");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [validationError, setValidationError] = useState({
        content: false,
        attachment: false,
        recipients: false,
    });
    const fileInputRef = useRef(null);
    const notify = useNotification();
    const showConfirmation = useConfirmation();
    const [selectedPriority, setSelectedPriority] = useState(null);
    console.log("Selected Priority:", selectedPriority)

    const userRole = Cookies.get("userRole")?.split(",")[0];
    
    useEffect(() => {
        const loadData = async () => {
            const [templates, groups] = await Promise.all([
                fetchTemplates(userId,userRole),
                fetchGroups(userId),
            ]);
            setTemplates(templates);
            setOptions(groups);
        };
        loadData();
    }, [userId, userRole]);

    const handlePhoneChange = (e) => {
        setPhoneValue(e.target.value);
    };

    
const fetchTemplates = async (userId) => {
    try {
        const response = await axios.post(
                "http://api.virtualprachar.com/api/whatsapp-template/getbyroleanduserid",
                {
                   
                        user_id :userId,
                        role: userRole,
                },
                {
                headers: {
                    "Content-Type": "application/json",
                },
            }
            );
        return response.data.data || [];
        // setTemplates(response.data.data || [])
    } catch (error) {
        console.error("Error fetching templates:", error);
        return [];
    }
};

    const fetchGroups = async (userId) => {
        try {
            const res = await axios.get(`${base_url}/get/${userId}`);
            return [...new Set(res.data.data.map((obj) => obj.group_name))];
        } catch (e) {
            console.error("Error fetching groups:", e);
            return [];
        }
    };

    const validateCurrentStep = () => {
        if (activeStep === 1) {
            // Attachments step
            // Check if either content or attachment exists
            const hasContent = customMessage || selectedTemplate;
            const hasAttachment = imgUrl || image.length > 0;

            if (!hasContent && !hasAttachment) {
                setValidationError({
                    content: true,
                    attachment: true,
                    recipients: false,
                });
                notify(
                    "Please provide either content or an attachment",
                    "error"
                );
                return false;
            }

            // If image selected but not uploaded
            if (image.length > 0 && !imgUrl) {
                setValidationError({
                    content: false,
                    attachment: true,
                    recipients: false,
                });
                notify(
                    "Please upload the selected file before proceeding",
                    "error"
                );
                return false;
            }

            setValidationError({
                content: false,
                attachment: false,
                recipients: false,
            });
            return true;
        }

        if (activeStep === 2) {
            // Recipients step
            if (contacts.length === 0 && phoneNumber.length === 0) {
                setValidationError({
                    content: false,
                    attachment: false,
                    recipients: true,
                });
                notify("Please add at least one recipient", "error");
                return false;
            }
            return true;
        }

        // No validation for first step (content is optional)
        return true;
    };

    const handleNext = () => {
        if (!validateCurrentStep()) return;
        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
    };

    const handleTemplateSelect = (template) => {
        setSelectedTemplate(template);
        setCustomMessage(template.template || "");
        // setValidationError((prev) => ({ ...prev, content: false }));
    };

    const handleAddNumber = () => {
        if (!phoneValue) {
            notify("Please enter a phone number!", "warning");
            return;
        }

        let formattedNumber = phoneValue.replace(/\D/g, "");
        if (!formattedNumber.startsWith("91")) {
            formattedNumber = `91${formattedNumber}`;
        }

        if (!/^[0-9]{12}$/.test(formattedNumber)) {
            notify("Invalid phone number", "warning");
            return;
        }

        setPhoneNumber((prev) => [...prev, formattedNumber]);
        setContacts((prev) => [
            ...prev,
            { phoneNumber: formattedNumber, name: null },
        ]);
        setPhoneValue("");
        setValidationError((prev) => ({ ...prev, recipients: false }));
    };

    const handleDelete = (idx) => {
        setContacts((prev) => prev.filter((_, i) => i !== idx));
        setPhoneNumber((prev) => prev.filter((_, i) => i !== idx));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const validTypes = [
            "image/jpeg",
            "image/png",
            "image/jpg",
            "application/pdf",
            "video/mp4",
        ];

        if (!validTypes.includes(file.type)) {
            notify(
                "Invalid file type. Please upload an image, PDF, or MP4 video.",
                "error"
            );
            return;
        }

        if (file.size > 10 * 1024 * 1024) {
            notify(
                "File size exceeds 10MB. Please upload a smaller file.",
                "error"
            );
            return;
        }

        setImage([file]);
        setValidationError((prev) => ({ ...prev, attachment: false }));
    };

    const handleImageUpload = async () => {
        if (image.length === 0) {
            notify("No file has been selected.", "error");
            return;
        }

        const payload = new FormData();
        payload.append("image", image[0]);
        payload.append("user_id", userId);

        setBtnLoading(true);
        try {
            const res = await axios.post(
                "http://api.virtualprachar.com/api/upload/image",
                payload
            );
            const newUrl = `http://api.virtualprachar.com/${res.data.path}`;
            notify("File uploaded successfully!", "success");
            setImgUrl(newUrl);
        } catch (e) {
            console.error("Error:", e);
            notify(e.response?.data?.message || e.message, "error");
        } finally {
            setBtnLoading(false);
        }
    };

    const handleClearUploads = () => {
        setImage([]);
        setImgUrl("");
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const handleSelectionChange = (e) => {
        setSearchGName(e.target.value);
        setPage(1);
        setContacts([]);
    };

    const fetchGroupData = async () => {
        if (!searchedGName) {
            notify("Please enter group name!", "warning");
            return;
        }

        try {
            setLoading(true);
            const res = await axios.get(
                `${base_url}/get?user_id=${userId}&group_name=${searchedGName}&page=${page}`
            );

            const newData = res.data.data.data.map((obj) => ({
                phoneNumber: obj.phone_number,
                name: null,
            }));

            setContacts((prev) => [...prev, ...newData]);
            setPage((prev) => prev + 1);
            setTotalPage(res.data.data.last_page);
            setValidationError((prev) => ({ ...prev, recipients: false }));
        } catch (e) {
            console.error("Error:", e);
            notify("Error while loading group data!", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleClearContacts = () => {
        setContacts([]);
        setPhoneNumber([]);
        setPage(1);
        setSearchGName("");
    };

    const handleSubmit = async () => {
        // Final validation
        const hasContent = customMessage || selectedTemplate;
        const hasAttachment = imgUrl || image.length > 0;

        if (!hasContent && !hasAttachment) {
            notify("Please provide either content or an attachment", "error");
            return;
        }

        if (image.length > 0 && !imgUrl) {
            notify("Selected file has not been uploaded yet", "error");
            return;
        }

        if (!hasContent && !hasAttachment) {
            const confirm = await showConfirmation(
                "Do you want to proceed without content or attachment?"
            );
            if (!confirm) return;
        }

        let payload;
        if (searchedGName) {
            payload = [
                {
                    user_id: userId,
                    group_name: searchedGName,
                    image_url: imgUrl,
                    message: customMessage,
                    message_priority:selectedPriority
                },
            ];
            console.log("payload:", payload)

            setDrawerOpen(true);
            return;
        } else {
            payload = phoneNumber.map((phone) => ({
                user_id: userId,
                phone_number: phone,
                message: customMessage,
                image_url: imgUrl,
                message_priority:selectedPriority
            }));
            console.log("PAYLOAD:", payload)
        }
        
        try {
            await axios.post(`${baseUrl}/add`, payload);
            notify("Message added to queue!", "success");
            resetForm();
        } catch (error) {
            console.error("Error sending data:", error);
            notify("Something went wrong, please try again!", "error");
        }
    };

    const handleSaveContent = async () => {
        try {
            await axios.post(`${baseUrl}/add`, [
                {
                    user_id: userId,
                    group_name: searchedGName,
                    image_url: imgUrl,
                    message: customMessage,
                    message_priority:selectedPriority
                },
            ]);
            notify("Message added to queue!", "success");
            setDrawerOpen(false);
            resetForm();
        } catch (error) {
            console.error("Error sending data:", error);
            notify("Something went wrong, please try again!", "error");
        }
    };

    const resetForm = () => {
        setCustomMessage("");
        setImage([]);
        setImgUrl("");
        setPhoneNumber([]);
        setContacts([]);
        setSearchGName("");
        setSelectedTemplate(null);
        setActiveStep(0);
        setValidationError({
            content: false,
            attachment: false,
            recipients: false,
        });
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const closeDrawer = () => {
        setDrawerOpen(false);
        handleSaveContent();
    };

    return (
        <Box sx={{ width: "100%", p: 3 }}>
            <CustomizedDrawer
                message={"Do you want to proceed with group?"}
                drawerOpen={drawerOpen}
                closeDrawer={closeDrawer}
                onCancel={() => setDrawerOpen(false)}
            />

            <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <Paper sx={{ p: 3, mb: 3 }}>
                {activeStep === 0 && (
                    <MessageStep
                        templates={templates}
                        selectedTemplate={selectedTemplate}
                        onTemplateSelect={handleTemplateSelect}
                        customMessage={customMessage}
                        onMessageChange={(e) => {
                            setCustomMessage(e.target.value);
                            setValidationError((prev) => ({
                                ...prev,
                                content: false,
                            }));
                        }}
                        hasError={validationError.content}
                    />
                )}

                {activeStep === 1 && (
                    <AttachmentStep
                        image={image}
                        imgUrl={imgUrl}
                        btnLoading={btnLoading}
                        onImageChange={handleImageChange}
                        onImageUpload={handleImageUpload}
                        onClearUploads={handleClearUploads}
                        fileInputRef={fileInputRef}
                        hasError={validationError.attachment}
                    />
                )}

                {activeStep === 2 && (
                    <RecipientStep
                        phoneValue={phoneValue}
                        phoneNumber={phoneNumber}
                        contacts={contacts}
                        searchedGName={searchedGName}
                        options={options}
                        loading={loading}
                        page={page}
                        totalPage={totalPage}
                        onPhoneChange={handlePhoneChange}
                        onAddNumber={handleAddNumber}
                        onDelete={handleDelete}
                        onSelectionChange={handleSelectionChange}
                        onFetchGroupData={fetchGroupData}
                        onClearContacts={handleClearContacts}
                        hasError={validationError.recipients}
                        onSelectPriority={setSelectedPriority}
                    />
                )}
            </Paper>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                >
                    Back
                </Button>

                {activeStep === steps.length - 1 ? (
                    <Button variant="contained" onClick={handleSubmit}>
                        Send Message
                    </Button>
                ) : (
                    <Button variant="contained" onClick={handleNext}>
                        Next
                    </Button>
                )}
            </Box>

            <Box
                sx={{
                    mt: 4,
                    p: 2,
                    border: 1,
                    borderColor: "divider",
                    borderRadius: 1,
                }}
            >
                <Typography
                    variant="subtitle1"
                    gutterBottom
                    sx={{ fontWeight: "bold" }}
                >
                    Note*
                </Typography>
                <ul style={{ paddingLeft: "20px", margin: 0 }}>
                    <li>
                        <strong>Bold:</strong> *text* → <strong>text</strong>
                    </li>
                    <li>
                        <strong>Italic:</strong> _text_ → <em>text</em>
                    </li>
                    <li>
                        <strong>Strikethrough:</strong> ~text~ → <s>text</s>
                    </li>
                    <li>
                        <strong>Monospace:</strong> ```text``` →{" "}
                        <code>text</code>
                    </li>
                </ul>
            </Box>
        </Box>
    );
};

export default AddNumber;
